import React, { useRef } from "react";
import MieszkaniecWydrukButtons from './MieszkaniecWydrukButtons.js';
import MieszkaniecWydrukA4 from "./MieszkaniecWydrukA4.js";

const MieszkaniecWydruk = props => {

    const { udzialyKonta_a, showPrint, mieszkaniec, tablicaCzynszeAkt, stawkiOst, stawkiJednorazowe, stawkiJednorazoweInd, lokale, ulice, grupy_a, miesiac, grupa_numer, wodaMsc, procent } = props;

    const handleModalClick = (event) => event.stopPropagation();

    const componentRef = useRef(null);
    
    return (
        <div className="mieszkaniecWydruk" onClick={showPrint}>
            <div className="modal" onClick={handleModalClick}>
                <MieszkaniecWydrukA4
                    udzialyKonta_a={udzialyKonta_a}
                    mieszkaniec={mieszkaniec}
                    tablicaCzynszeAkt={tablicaCzynszeAkt}
                    stawkiOst={stawkiOst}
                    stawkiJednorazowe={stawkiJednorazowe}
                    stawkiJednorazoweInd={stawkiJednorazoweInd}
                    lokale={lokale}
                    ulice={ulice}
                    grupy_a={grupy_a}
                    miesiac={miesiac}
                    grupa_numer={grupa_numer}
                    componentRef={componentRef}
                    wodaMsc={wodaMsc}
                    procent={procent}
                />
                <MieszkaniecWydrukButtons
                    showPrint={showPrint}
                    componentRef={componentRef}
                />
            </div>
        </div>
    )
}

export default MieszkaniecWydruk;